import React from 'react';
const ToastMessage = ({ messages }) => {
    if (messages && !messages.pop) return (<span>{messages}</span>)
    return (<ul>
        {messages && messages.map((m, index) => <li key={index}>{m}</li>)}
    </ul>)
}
export default ToastMessage;